import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { ShFormTextComplexBaseComponent } from '../../form-text/base-complex/form-text-complex-base.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'sh-form-textarea-complex-base',
    templateUrl: './form-textarea-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTextareaComplexBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule, NgClass, AsyncPipe]
})
export class ShFormTextareaComplexBaseComponent extends ShFormTextComplexBaseComponent {
    @Input() resizable?: boolean = false;
    @Input() rows?: number;
}
